module.exports = __webpack_public_path__ + "static/media/img_b2b_networking.15af4d5f.jpg";